import { SDUIBannerRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/SDUIBannerRenderer";
import { SDUIRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SDUIRenderer/SDUIRenderer";
import { SDUIColumnSectionRenderer } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/ColumnSection/SDUIColumnSectionRenderer";
import {
  ComponentRenderMap,
  SectionRenderMap,
} from "@faire/retailer-visitor-shared/components/SDUI/types";
import { IViewLayout } from "@faire/web-api--source/indigofair/data/IViewLayout";
import React from "react";

interface IProps {
  viewLayout: IViewLayout;
}

const componentRenderers: ComponentRenderMap = {
  banner_component: {
    active: SDUIBannerRenderer,
  },
};

const sectionRenderers: SectionRenderMap = {
  column_section: SDUIColumnSectionRenderer,
};

export const ConductorHeroBanner: React.FC<IProps> = ({ viewLayout }) => {
  return (
    <SDUIRenderer
      viewLayout={viewLayout}
      componentRenderers={componentRenderers}
      sectionRenderers={sectionRenderers}
      UPLTprops={{
        shouldRenderBelowTheFold: false,
      }}
    />
  );
};
